// Collections.js
import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Notiflix from "notiflix";
import { FaShoppingBag } from 'react-icons/fa';
import './Dashboard.css';
import PlaceOrderIcon from './PlaceOrderIcon.svg'; 
import CollectionIcon2 from './collection2.svg';
import { endpoint } from './endpoint';
import CollectionDisplay from "./CollectionDisplay";
import { UserContext } from './UserContext'; // Import UserContext

const Collections = () => {
    const { user } = useContext(UserContext); // Access user data from context
    const [pendingOrders, setPendingOrders] = useState([]);
    const [expandedOrder, setExpandedOrder] = useState(null);
    const [subscription, setSubscription] = useState(null);
    const [isSubscribed, setIsSubscribed] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) {
            return;
        }

        fetch(`${endpoint}/gymapp/getpendingorders.php?token=${user.token}`)
            .then(res => res.json())
            .then(data => {
                setPendingOrders(data);
            });

        fetch(`${endpoint}/gymapp/getsubscription.php?token=${user.token}`)
            .then(res => res.json())
            .then(data => {
                setSubscription(data.subscription);
                setIsSubscribed(!!data.subscription); // Check if user has an active subscription
            });
    }, [navigate, user]);

    const handleLogout = () => {
        localStorage.removeItem('authToken');
        navigate('/login');
    };

    const handleViewDetails = (order) => {
        setExpandedOrder(prevState => prevState === order._collectionID ? null : order._collectionID);
    };

    if (!user) {
        return <div>Loading...</div>;
    }

    return (
        <div className="container mt-4">
            <div className="row">
                <div className="col">
                    <br/><br/>
                    <h3 className="mb-3" style={{paddingTop:"10px"}}>Pending Orders</h3>
                    <hr/>
                   
                </div>
            </div>
            <div className="row">
                {pendingOrders.length > 0 && pendingOrders.map((order) => (
                    <div className="col-lg-3 col-md-6 col-sm-12 mb-4" key={order._collectionID}>
                        <div className="card h-100 text-center" style={{padding:"10px"}}>
                            <img src={CollectionIcon2} style={{maxWidth:"150px",margin:"auto"}} className="card-img-top" alt="Collection Icon" />
                            <div className="card-body">
                                <CollectionDisplay color="black" _collectionID={order._collectionID} />
                                <p className="card-text"><strong>Status:</strong> {order.status}</p>
                                <button 
                                    className="btn-sm" 
                                    onClick={() => handleViewDetails(order)}
                                >
                                    {expandedOrder === order._collectionID ? "Hide Details" : "View Details"}
                                </button>
                                {expandedOrder === order._collectionID && (
                                    <div className="mt-3 p-3 bg-light rounded">
                                        <p><strong>Paid:</strong> R {order._amount}</p>
                                        <p><strong>Bags:</strong> {JSON.parse(order._bags).map((bag, index) => (
                                            <span key={index} className="me-2">
                                                <FaShoppingBag /> {bag}
                                            </span>
                                        ))}</p>
                                        <p><strong>Status:</strong> {order.status}</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <br/><br/><br/>
        </div>
    );
};

export default Collections;
